import React from 'react';

const Notice = () => <h1> 공지사항 게시판입니다..  (mysql 연동) </h1>;

export default Notice;